import { render, staticRenderFns } from "./diyCanvas.vue?vue&type=template&id=2cbef11e&scoped=true&"
import script from "./diyCanvas.vue?vue&type=script&lang=js&"
export * from "./diyCanvas.vue?vue&type=script&lang=js&"
import style0 from "./diyCanvas.vue?vue&type=style&index=0&id=2cbef11e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cbef11e",
  null
  
)

export default component.exports